import { render, staticRenderFns } from "./zhuanke.vue?vue&type=template&id=59c8b737&scoped=true&"
import script from "./zhuanke.vue?vue&type=script&lang=js&"
export * from "./zhuanke.vue?vue&type=script&lang=js&"
import style0 from "./zhuanke.vue?vue&type=style&index=0&id=59c8b737&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8b737",
  null
  
)

export default component.exports